import { useQuery } from 'react-query';

import { useTiming } from '@/hooks/useTiming';
import { getAzureToken as getTtsData } from '@/services/api';
import { logger } from '@/services/logger';

export default function () {
    const { wrapWithTiming } = useTiming();
    return useQuery('get-tts-data', wrapWithTiming('getTtsData', getTtsData), {
        staleTime: 1000 * 60 * 5,
        onError: error => {
            logger.error('Could not fetch tts data', { error });
        },
        retry: 3,
    });
}
